import SpriteSymbol from "../../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-805",
  "use": "icon-805-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" class=\"qi-805\" viewBox=\"0 0 16 16\" id=\"icon-805\">\n  <path d=\"M0 8a8 8 0 1 0 8-8 8 8 0 0 0-8 8zm1 0a7.008 7.008 0 0 1 7-7 6.613 6.613 0 0 1 .881.063.702.702 0 0 1 .36.157A8.868 8.868 0 0 1 12.036 8a8.838 8.838 0 0 1-2.849 6.822.486.486 0 0 1-.24.106A6.73 6.73 0 0 1 8 15a7.008 7.008 0 0 1-7-7z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol